// // import React from "react";

// import React from "react";
// import { Box, Typography, Button, Stack, useMediaQuery } from "@mui/material";
// import { styled } from "@mui/system";

// const StyledCard = styled(Box)(({ theme }) => ({
//   borderRadius: "15px",
//   padding: "20px",
//   color: "#fff",
//   boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//   transition: "transform 0.3s ease-in-out", // Smooth animation
//   "&:hover": {
//     transform: "translateY(-12px)", // Move up on hover
//   },
// }));

// const TwoCardsSection = () => {
//   const isMobile = useMediaQuery("(max-width:600px)");

//   return (
//     <Stack
//       sx={{
//         display: "flex",
//         flexDirection: "row",
//         justifyContent: "center",
//       }}
//     >
//       <Stack
//         direction={isMobile ? "column" : "row"}
//         spacing={6}
//         justifyContent="space-between"
//         alignItems="center"
//         sx={{ padding: "20px", width: { xl: "80%" } }}
//       >
//         {/* First Card */}
//         <StyledCard
//           sx={{
//             backgroundColor: "#0043CE",
//             width: isMobile ? "100%" : "45%",
//             textAlign: isMobile ? "center" : "left",
//           }}
//         >
//           <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//             🌐 Start <span style={{ color: "#FFD700" }}>7 Days Free</span> Trial
//           </Typography>
//           <Typography sx={{ marginTop: "10px", fontSize: "14px" }}>
//             You are just one step to automate and unify your business
//             communications
//           </Typography>
//           <Stack
//             direction="row"
//             spacing={2}
//             justifyContent={isMobile ? "center" : "flex-start"}
//             sx={{ marginTop: "15px", flexWrap: "wrap" }}
//           >
//             <Typography>📄 No Credit Card</Typography>
//             <Typography>✅ Instant Activation</Typography>
//             <Typography>✅ Access All Features</Typography>
//           </Stack>
//           <Button
//             variant="contained"
//             sx={{
//               marginTop: "15px",
//               backgroundColor: "#6C63FF",
//               color: "#fff",
//               textTransform: "none",
//               borderRadius: "20px",
//               padding: "10px 20px",
//               fontWeight: "bold",
//               "&:hover": {
//                 backgroundColor: "#5b54d6",
//               },
//               "&::before": {
//                 content: '""',
//                 position: "absolute",
//                 top: 0,
//                 left: "-100%",
//                 width: "50%",
//                 height: "100%",
//                 background:
//                   "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)",
//                 transform: "skewX(-45deg)",
//                 animation: "lightSweep 2s infinite", // Add animation
//               },
//             }}
//           >
//             Signup Now →
//           </Button>
//         </StyledCard>

//         {/* Second Card */}
//         <StyledCard
//           sx={{
//             backgroundColor: "#073B4C",
//             width: isMobile ? "100%" : "45%",
//             textAlign: isMobile ? "center" : "left",
//           }}
//         >
//           <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//             🎧 Need <span style={{ color: "#FFD700" }}>Human Assistance?</span>
//           </Typography>
//           <Typography sx={{ marginTop: "10px", fontSize: "14px" }}>
//             Schedule a Meeting with our Solution Expert for One to One
//             Assistance
//           </Typography>
//           <Stack
//             direction="row"
//             spacing={2}
//             justifyContent={isMobile ? "center" : "flex-start"}
//             sx={{ marginTop: "15px", flexWrap: "wrap" }}
//           >
//             <Typography>💬 Discuss Requirements</Typography>
//             <Typography>💡 Solution Suggestion</Typography>
//             <Typography>📋 Plan Suggestion</Typography>
//           </Stack>
//           <Button
//             variant="contained"
//             sx={{
//               marginTop: "15px",
//               backgroundColor: "#F4A261",
//               color: "#fff",
//               textTransform: "none",
//               borderRadius: "20px",
//               padding: "10px 20px",
//               fontWeight: "bold",
//               "&:hover": {
//                 backgroundColor: "#e68a3c",
//               },
//               "&::before": {
//                 content: '""',
//                 position: "absolute",
//                 top: 0,
//                 left: "-100%",
//                 width: "100%",
//                 height: "100%",
//                 background:
//                   "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)",
//                 transform: "skewX(-45deg)",
//                 animation: "lightSweep 2s infinite", // Add animation
//               },
//             }}
//           >
//             Schedule Meeting →
//           </Button>
//         </StyledCard>
//       </Stack>
//       {/* Add the keyframes animation */}
//       <style>
//         {`
//           @keyframes lightSweep {
//             0% {
//               left: -100%;
//             }
//             50% {
//               left: 50%;
//             }
//             100% {
//               left: 100%;
//             }
//           }
//         `}
//       </style>
//     </Stack>
//   );
// };

// export default TwoCardsSection;
import React from "react";
import { Box, Typography, Button, Stack, useMediaQuery } from "@mui/material";
import { styled } from "@mui/system";

const StyledCard = styled(Box)(({ theme }) => ({
  borderRadius: "15px",
  padding: "20px",
  color: "#fff",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.3s ease-in-out", // Smooth animation
  "&:hover": {
    transform: "translateY(-12px)", // Move up on hover
  },
}));

const TwoCardsSection = () => {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        my: 4,
      }}
    >
      <Stack
        direction={isMobile ? "column" : "row"}
        spacing={6}
        justifyContent="space-between"
        alignItems="center"
        sx={{ padding: "20px", width: { xl: "72%", lg: "92%", sm: "96%" } }}
      >
        {/* First Card */}
        <StyledCard
          sx={{
            backgroundColor: "#0043CE",
            width: isMobile ? "100%" : "45%",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            🌐 Start <span style={{ color: "#FFD700" }}>7 Days Free</span> Trial
          </Typography>
          <Typography sx={{ marginTop: "10px", fontSize: "14px" }}>
            You are just one step to automate and unify your business
            communications
          </Typography>
          <Stack
            direction="row"
            spacing={2}
            justifyContent={isMobile ? "center" : "flex-start"}
            sx={{ marginTop: "15px", flexWrap: "wrap" }}
          >
            <Typography>📄 No Credit Card</Typography>
            <Typography>✅ Instant Activation</Typography>
            <Typography>✅ Access All Features</Typography>
          </Stack>
          <Button
            variant="contained"
            sx={{
              position: "relative",
              overflow: "hidden", // Prevent the animation from exceeding the button's area
              marginTop: "15px",
              backgroundColor: "#6C63FF",
              color: "#fff",
              textTransform: "none",
              borderRadius: "20px",
              padding: "10px 20px",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#5b54d6",
              },
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "150%",
                height: "100%",
                background:
                  "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
                transform: "skewX(-45deg)",
                animation: "lightSweep 2s infinite",
              },
            }}
          >
            Signup Now →
          </Button>
        </StyledCard>

        {/* Second Card */}
        <StyledCard
          sx={{
            backgroundColor: "#073B4C",
            width: isMobile ? "100%" : "45%",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            🎧 Need <span style={{ color: "#FFD700" }}>Human Assistance?</span>
          </Typography>
          <Typography sx={{ marginTop: "10px", fontSize: "14px" }}>
            Schedule a Meeting with our Solution Expert for One to One
            Assistance
          </Typography>
          <Stack
            direction="row"
            spacing={2}
            justifyContent={isMobile ? "center" : "flex-start"}
            sx={{ marginTop: "15px", flexWrap: "wrap" }}
          >
            <Typography>💬 Discuss Requirements</Typography>
            <Typography>💡 Solution Suggestion</Typography>
            <Typography>📋 Plan Suggestion</Typography>
          </Stack>
          <Button
            variant="contained"
            sx={{
              position: "relative",
              overflow: "hidden", // Prevent the animation from exceeding the button's area
              marginTop: "15px",
              backgroundColor: "#F4A261",
              color: "#fff",
              textTransform: "none",
              borderRadius: "20px",
              padding: "10px 20px",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#e68a3c",
              },
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "150%",
                height: "100%",
                background:
                  "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
                transform: "skewX(-45deg)",
                animation: "lightSweep 2s infinite",
              },
            }}
          >
            Schedule Meeting →
          </Button>
        </StyledCard>
      </Stack>

      {/* Add the keyframes animation */}
      <style>
        {`
          @keyframes lightSweep {
            0% {
              left: -50%;
            }
            50% {
              left: 50%;
            }
            100% {
              left: 50%;
            }
          }
        `}
      </style>
    </Stack>
  );
};

export default TwoCardsSection;
